import Icon from '../components/Icon.vue'

Icon.register({
  'fill-drip': {
    width: 576,
    height: 512,
    paths: [
      {
        d: 'M512 320S448 412.6 448 448C448 483.4 476.7 512 512 512S576 483.4 576 448 512 320 512 320zM502.6 217.1L294.9 9.4C288.7 3.1 280.5 0 272.3 0S255.9 3.1 249.7 9.4L168.1 90.9 81.9 4.8C75.7-1.5 65.5-1.5 59.3 4.8L36.7 27.4C30.4 33.6 30.4 43.8 36.7 50L122.9 136.2 28.1 230.9C-9.4 268.4-9.4 329.2 28.1 366.7L145.3 483.9C164.1 502.6 188.6 512 213.2 512 237.8 512 262.3 502.6 281.1 483.9L502.6 262.3C515.1 249.8 515.1 229.6 502.6 217.1zM386.4 288H65.9C67.3 284.2 69.5 280 73.4 276.2L86.5 263.1 168.1 181.4 226.7 240C239.2 252.5 259.5 252.5 272 240S284.4 207.3 272 194.8L213.4 136.2 272.3 77.3 434.8 239.7 386.4 288z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/fill-drip.js
// module id = 5Vwf
// module chunks = 144